<button
  type="button"
  class="bs-button"
  [ngClass]="[type ? type : '', outline ? 'outline' : '', size ? size : '']"
  [disabled]="isDisabled"
><fa-icon *ngIf="icon" [icon]="icon"></fa-icon>{{ value }}</button>
